import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  localesList = [
    { code: 'ca', label: 'CA' },
    { code: 'es', label: 'ES' }
  ];
  selectedLocale = 'ca';

  highContrast = false;
  textSize = 14;
  zoom = 1;

  actualUrl = '';

  constructor(
    private router: Router,
    public authService: AuthService
  ) {
    this.selectedLocale =
      window.location.pathname.indexOf('/es/') > -1 ? 'es' :
      window.location.pathname.indexOf('/en/') > -1 ? 'en' :
      window.location.pathname.indexOf('/fr/') > -1 ? 'fr' :
      'ca';
    this.actualUrl = window.location.pathname;
    this.highContrast = sessionStorage.getItem('highContrast') === 'true';
    this.setContrast();
  }

  ngOnInit() {}

  ngOnDestroy() {}

  changeLocale(event: any) {
    const localeSelected = (event.target as HTMLSelectElement).value;
    window.location.href = `/${localeSelected}` + window.location.pathname.replace('/es/', '/').replace('/ca/', '/').replace('/en/', '/').replace('/fr/', '/');
  }

  goToLogin() {
    this.router.navigate(['/login']);
  }

  logout() {
    this.authService.logoutUser();
    this.router.navigate(['/home']);
  }

  toggleContrast() {
    this.highContrast = !this.highContrast;
    sessionStorage.setItem('highContrast', this.highContrast ? 'true' : 'false');
    this.setContrast();
  }

  setContrast() {
    if (this.highContrast) {
      document.documentElement.style.setProperty('--my-primary', 'blue');
      document.documentElement.style.setProperty('--my-primary-light', 'blue');
      document.documentElement.style.setProperty('--my-primary-shade', 'blue');
  
      document.documentElement.style.setProperty('--my-secondary', 'black');
      document.documentElement.style.setProperty('--my-secondary-light', 'rgb(0 0 0 / 80%)');
      document.documentElement.style.setProperty('--my-secondary-shade', 'rgb(0 0 0 / 20%)');
  
      document.documentElement.style.setProperty('--featured', 'orange');
      document.documentElement.style.setProperty('--featured-shade', 'orange');

      document.documentElement.style.setProperty('--danger-bg', '#970000');

  
      document.documentElement.style.setProperty('--background-color', 'white');
      document.documentElement.style.setProperty('--background-color-dark', 'black');
      document.documentElement.style.setProperty('--background-light-dark', 'white');
      document.documentElement.style.setProperty('--border-color', 'gray');
  
      document.documentElement.style.setProperty('--font-color', 'black');
      document.documentElement.style.setProperty('--font-color-dark', 'white');

      document.documentElement.style.setProperty('--my-link-color', 'blue');
      document.documentElement.style.setProperty('--required-color', '#970000');
  
      document.documentElement.style.setProperty('--font-family', "'Roboto', sans-serif");
  
      document.documentElement.style.setProperty('--header-background', 'white');
      document.documentElement.style.setProperty('--header-text', 'black');
      document.documentElement.style.setProperty('--header-active', 'black');
  
      document.documentElement.style.setProperty('--footer-background', 'black');
      document.documentElement.style.setProperty('--footer-text', 'white');
  
      document.documentElement.style.setProperty('--background-gradient', 'white');

      // badges
      document.documentElement.style.setProperty('--pendiente-color', '#7a4300');
    } else {
      document.documentElement.style.setProperty('--my-primary', '#008edf');
      document.documentElement.style.setProperty('--my-primary-light', 'rgb(0 142 223 / 80%)');
      document.documentElement.style.setProperty('--my-primary-shade', '#042735');
  
      document.documentElement.style.setProperty('--my-secondary', 'black');
      document.documentElement.style.setProperty('--my-secondary-light', 'rgb(0 0 0 / 80%)');
      document.documentElement.style.setProperty('--my-secondary-shade', 'rgb(0 0 0 / 20%)');
  
      document.documentElement.style.setProperty('--featured', '#e9ce2cb3');
      document.documentElement.style.setProperty('--featured-shade', '#E9DE9E');

      document.documentElement.style.setProperty('--danger-bg', '#dc3545');
  
      document.documentElement.style.setProperty('--background-color', 'white');
      document.documentElement.style.setProperty('--background-color-dark', '#08090A');
      document.documentElement.style.setProperty('--background-light-dark', '#efefef');
      document.documentElement.style.setProperty('--border-color', '#aeaeae');
  
      document.documentElement.style.setProperty('--font-color', '#324A6D');
      document.documentElement.style.setProperty('--font-color-dark', '#EAFDF8');

      document.documentElement.style.setProperty('--my-link-color', '#008edf');
      document.documentElement.style.setProperty('--required-color', '#970000');
  
      document.documentElement.style.setProperty('--font-family', "'Roboto', sans-serif");
  
      document.documentElement.style.setProperty('--header-background', 'white');
      document.documentElement.style.setProperty('--header-text', '#1C244B');
      document.documentElement.style.setProperty('--header-active', '#324A6D');
  
      document.documentElement.style.setProperty('--footer-background', '#666');
      document.documentElement.style.setProperty('--footer-text', 'white');
  
      document.documentElement.style.setProperty('--background-gradient', 'white');

      // badges
      document.documentElement.style.setProperty('--pendiente-color', 'orange');
    }
  }

  moreTextSize() {
    // this.textSize += 2;
    // document.documentElement.style.setProperty('--font-size', `${this.textSize}px`);
    this.zoom += 0.1;
    (document.body.style as any).zoom = this.zoom.toString();
  }

  lessTextSize() {
    // this.textSize -= 2;
    // document.documentElement.style.setProperty('--font-size', `${this.textSize}px`);
    this.zoom -= 0.1;
    (document.body.style as any).zoom = this.zoom.toString();
  }

  getRoleName() {
    let roleName = '';
    switch (this.authService.getCurrentUser().rol) {
      case 'level1':
        roleName = $localize`:@@Role.Level1:Nivel 1`;
        break;
      case 'level2':
        roleName = $localize`:@@Role.Level2:Nivel 2`;
        break;
      case 'administrator':
        roleName = $localize`:@@Role.Administrator:Administrador`;
        break;
      default:
        roleName = this.authService.getCurrentUser().rol;
    }
    return roleName;
  }
}
